import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function SettingsPanel({ onClose }) {
  const { currentUser, practiceData, setPracticeData, isDemo } = useAuth();
  const { addToast } = useToast();
  const [name, setName] = useState(practiceData?.practiceName || '');
  const [phone, setPhone] = useState(practiceData?.phone || '');
  const [notifs, setNotifs] = useState(false);
  const [saving, setSaving] = useState(false);

  async function handleSave(e) {
    e.preventDefault();
    if (isDemo) { addToast('Settings are read-only in demo mode', 'info'); return; }
    setSaving(true);
    try {
      await updateDoc(doc(db, 'practices', currentUser.uid), { practiceName: name, phone });
      setPracticeData(d => ({ ...d, practiceName: name, phone }));
      addToast('Settings saved');
      onClose();
    } catch {
      addToast('Failed to save settings', 'error');
    }
    setSaving(false);
  }

  return (
    <div style={overlayStyle} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={panelStyle}>
        <div style={headerStyle}>
          <span style={titleStyle}>Practice settings</span>
          <button onClick={onClose} style={closeBtnStyle}><X size={18} /></button>
        </div>

        <form onSubmit={handleSave} style={{ padding: '28px', display: 'flex', flexDirection: 'column', gap: 20, flex: 1 }}>
          <div style={fieldStyle}>
            <label style={labelStyle}>Practice name</label>
            <input style={inputStyle} value={name} onChange={e => setName(e.target.value)} placeholder="Bright Smiles Dental" />
            <p style={hintStyle}>This name is used in patient messages.</p>
          </div>

          <div style={fieldStyle}>
            <label style={labelStyle}>Practice phone number</label>
            <input style={inputStyle} value={phone} onChange={e => setPhone(e.target.value)} placeholder="+65 6123 4567" />
          </div>

          <div style={{ borderTop: '1px solid #E5E5E0', paddingTop: 20 }}>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#9A9A92', marginBottom: 12 }}>
              Notification preferences
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={notifs}
                onChange={e => setNotifs(e.target.checked)}
                style={{ width: 16, height: 16, cursor: 'pointer' }}
              />
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 13, color: '#1B2B4B' }}>
                Daily overdue patient reminders
              </span>
            </label>
            <p style={{ ...hintStyle, marginTop: 8 }}>Notification delivery coming in a future update.</p>
          </div>

          <div style={{ marginTop: 'auto', display: 'flex', gap: 10 }}>
            <button type="button" onClick={onClose} style={cancelBtnStyle}>Cancel</button>
            <button type="submit" style={saveBtnStyle} disabled={saving}>
              {saving ? 'Saving...' : 'Save settings'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1000, display: 'flex', justifyContent: 'flex-end' };
const panelStyle = { background: '#fff', width: 420, maxWidth: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', boxShadow: '-4px 0 24px rgba(0,0,0,0.12)' };
const headerStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 28px', borderBottom: '1px solid #E5E5E0' };
const titleStyle = { fontFamily: "'JetBrains Mono', monospace", fontWeight: 700, fontSize: 16, color: '#1B2B4B' };
const closeBtnStyle = { background: 'none', border: 'none', cursor: 'pointer', color: '#7A7A72' };
const fieldStyle = { display: 'flex', flexDirection: 'column', gap: 6 };
const labelStyle = { fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#1B2B4B', fontFamily: "'JetBrains Mono', monospace" };
const inputStyle = { padding: '9px 11px', border: '1px solid #DDDDD8', borderRadius: 2, fontSize: 13, fontFamily: "'JetBrains Mono', monospace", color: '#1B2B4B', background: '#FAFAF8', outline: 'none' };
const hintStyle = { fontSize: 11, color: '#9A9A92', margin: 0, fontFamily: "'JetBrains Mono', monospace" };
const cancelBtnStyle = { flex: 1, padding: '11px 0', background: '#fff', color: '#1B2B4B', border: '1px solid #DDDDD8', borderRadius: 2, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: "'JetBrains Mono', monospace" };
const saveBtnStyle = { flex: 2, padding: '11px 0', background: '#1B2B4B', color: '#fff', border: 'none', borderRadius: 2, cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: "'JetBrains Mono', monospace" };
